export default "__VITE_ASSET__B$CDGRbl__"